import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.projects.data.ProjectContainer.';

  public static readonly projectIsNull = `${Id.prefix}projectIsNull`;
  public static readonly projectTitle = `${Id.prefix}projectTitle`;
  public static readonly projectSaved = `${Id.prefix}projectSaved`;
}

export class LangProjectContainer {
  private constructor() {}

  public static projectIsNull(): string {
    return interpolate(Id.projectIsNull);
  }
  public static projectTitle(params: { projectNumber: string; title: string }): string {
    return interpolate(Id.projectTitle, params);
  }
  public static projectSaved(params: { projectTitle: string }): string {
    return interpolate(Id.projectSaved, params);
  }
}

export class ProjectContainerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.projectIsNull, "{{glossary 'project'}} is null", 'Error message when project is null');
    register.add(Id.projectTitle, '#{{projectNumber}} - {{title}}', 'Formatted project title with number and title');
    register.add(
      Id.projectSaved,
      '{{glossary \'project\'}} Saved "{{projectTitle}}"',
      'Toast message for project saved'
    );
  }
}
